import React, { useState } from 'react';

import {
  useCurrentPlatformUsageInformationQuery,
  usePlatformBillingInformationQuery,
  useUpdatePlatformBillingPlanMutation,
  type WaypointFeatureTier,
} from '@dashboard/generated/wp/platform';
import { alertError, alertSuccess } from '@wp-react/notifications';

import SelectPlanDialog from '../SelectPlanDialog';

import CreditCardInfoDialog from './CreditCardInfoDialog';

type Props = {
  tier: WaypointFeatureTier;
  onClose: () => void;
};

type TSubmitProps = {
  tier: WaypointFeatureTier;
  paymentMethodId?: string;
};

export default function BillingPlansDialog({ tier, onClose }: Props) {
  const { data } = usePlatformBillingInformationQuery();
  const [updatePlan, { loading }] = useUpdatePlatformBillingPlanMutation();
  const { refetch: refetchUsageInformation } = useCurrentPlatformUsageInformationQuery();

  const billingPaymentInstrumentsCount = data?.PlatformBillingInformation.billingPaymentInstrumentsCount;

  const onSubmit = async (variables: TSubmitProps) => {
    try {
      await updatePlan({ variables });
      refetchUsageInformation();
      onClose();
      alertSuccess('Your plan has been successfully updated.');
    } catch {
      alertError('There was an error updating your plan.');
    }
  };

  const [planSelection, setPlanSelection] = useState<WaypointFeatureTier | null>(null);
  if (billingPaymentInstrumentsCount === undefined) {
    return null;
  }
  if (billingPaymentInstrumentsCount > 0) {
    return (
      <SelectPlanDialog
        planSelection={tier}
        loading={loading}
        onClose={onClose}
        onSubmit={async (tier) => {
          onSubmit({ tier });
        }}
      />
    );
  }
  if (planSelection === null) {
    return <SelectPlanDialog planSelection={tier} loading={loading} onClose={onClose} onSubmit={setPlanSelection} />;
  }
  return (
    <CreditCardInfoDialog
      loading={loading}
      reset={() => setPlanSelection(null)}
      tier={planSelection}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  );
}
